import styled from "styled-components";

export const Conteudo = styled.div`
  /* background-color: red !important; */
`;
